/**
 * Capacitor utilities for detecting wrapper environment
 * and managing native app features
 */

/**
 * Check if app is running in Capacitor wrapper (iOS/Android)
 */
export function isCapacitor(): boolean {
  if (typeof window === 'undefined') return false;

  // window.Capacitor finns även i webbuilden (bundlad @capacitor/core) —
  // bara isNativePlatform() skiljer riktig native-wrapper från web
  const capacitor = (window as any).Capacitor;
  return typeof capacitor?.isNativePlatform === 'function'
    ? capacitor.isNativePlatform() === true
    : false;
}

/**
 * Check if app is running on iOS
 */
export function isIOS(): boolean {
  if (typeof window === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

/**
 * Check if app is running on Android
 */
export function isAndroid(): boolean {
  if (typeof window === 'undefined') return false;
  return /Android/.test(navigator.userAgent);
}

/**
 * Get platform name
 */
export function getPlatform(): 'ios' | 'android' | 'web' {
  if (isIOS()) return 'ios';
  if (isAndroid()) return 'android';
  return 'web';
}

